import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface TableWrapperProps {
  selectedTransactionId?: string
}

export const TableWrapper = styled.div<TableWrapperProps>`
  ${({ selectedTransactionId }) =>
    selectedTransactionId &&
    `li[data-row-id='${selectedTransactionId}'] {
      background-color: ${Color.Grey50};
    }`}
`

/* Same technique as in side actions - not to overflow the row */
export const TableCellButtonWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: -${Spacing.S16};
  margin-bottom: -${Spacing.S16};
  vertical-align: middle;
`
